import { useIntl } from 'react-intl';
import { Stack, Typography } from '@rossum/ui/material';

export const NoAttachmentsFound = ({
  translationKey,
}: {
  translationKey:
    | 'emptyAttachmentsList'
    | 'suggestionsError'
    | 'genericError'
    | 'noAttachments';
}) => {
  const intl = useIntl();
  return (
    <Stack justifyContent="center" alignItems="center" height={1}>
      <Typography variant="body2">
        {intl.formatMessage({
          id: `components.modal.docAttachments.noAttachmentsFound.${translationKey}`,
        })}
      </Typography>
    </Stack>
  );
};
